module.exports = __webpack_public_path__ + "img/zhzx.299b9d3.svg";